import { render, staticRenderFns } from "./BankAccountEdit.vue?vue&type=template&id=a12e5938&"
import script from "./BankAccountEdit.vue?vue&type=script&lang=js&"
export * from "./BankAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports